import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BackupScheduleDTO } from 'src/app/model/backup-schedule-dto';
import { BackupService } from 'src/app/services/backup.service';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { EditBackupScheduleComponent } from '../modal/edit-backup-schedule/edit-backup-schedule.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { getDeviceTypeString } from 'src/app/model/backup-device-type';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-backups',
  templateUrl: './backup-schedules.component.html',
  styleUrl: './backup-schedules.component.scss'
})
export class BackupSchedulesComponent implements OnInit {
  public stopping: boolean = false
  public deleting: boolean = false
  public running: boolean = false
  public backupSchedules: BackupScheduleDTO[] | undefined;
  public daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

  constructor(
    public backupService: BackupService,
    public dialog: MatDialog,
    private readonly loadIndicatorService: LoadIndicatorService,
    private readonly toastr: ToastrService
  ){
    AppComponent.updateAppHeader('schedules', 'backups')
  }

  ngOnInit(): void {
    this.getBackupSchedules()
  }

  getBackupSchedules(){
    this.backupSchedules = []
    this.backupService.getBackupSchedules().then(response => {
      this.backupSchedules = response.items;
    }).finally(() => {
      this.loadIndicatorService.hide()
    })
  }

  getDeviceTypeString(deviceType?: number){
    return getDeviceTypeString(deviceType)
  }

  createSchedule(): void {
    this.editSchedule(undefined)
  }

  actionPending(): boolean {
    return this.stopping || this.deleting || this.running
  }

  toggleStopSchedule(schedule: BackupScheduleDTO){
    if(schedule?.id != null){
      schedule.enabled ?
      this.stopSchedule(schedule.id)
      : this.startSchedule(schedule.id)
    }
  }

  editSchedule(schedule: BackupScheduleDTO | undefined){
    const dialogRef = this.dialog.open(EditBackupScheduleComponent, {
      data: schedule,
    });

    dialogRef.afterClosed().subscribe((reload) => {
       if (reload === true) {
          this.getBackupSchedules()
       }
    })
  }

  public toggleSchedule(schedule: BackupScheduleDTO){
    schedule.opened = !schedule.opened;
  }

  public isScheduleDayActive(schedule: BackupScheduleDTO, dayIndex: number): boolean{
    return schedule?.days?.findIndex(x => x == dayIndex) !== -1
  }

  public runSchedule(schedule: BackupScheduleDTO){
    this.running = true

    if(schedule.id != null){
      this.backupService.runBackupSchedule(schedule.id)
      .then(response => {
        this.toastr.success('Backup started!')
      })
      .catch(error => {
        this.toastr.error('Error starting this backup.')
      })
      .finally(() => {
        this.running = false
      })
    }

  }

  public startSchedule(id: number){
    this.stopping = true

    this.backupService.startBackupSchedule(id)
      .then(response => {
        this.toastr.success('Schedule enabled!')
        this.getBackupSchedules()
      })
      .catch(error => {
        this.toastr.error('Error starting this schedule.')
      })
      .finally(() => {
        this.stopping = false
      })
  }

  public stopSchedule(id: number){
    this.stopping = true

    this.dialog.open(ConfirmationDialogComponent, {
      data: 'Do you want to stop this schedule?'
    }).afterClosed().subscribe((response) => {
      if(response === true){
        this.backupService.stopBackupSchedule(id)
        .then(response => {
          this.toastr.success('Schedule disabled!')
          this.getBackupSchedules()
        })
        .catch(error => {
          this.toastr.error('Error stopping this schedule.')
        })
        .finally(() => {
          this.stopping = false
        })
      }else{
        this.stopping = false
      }
    })
  }

  public deleteSchedule(schedule: BackupScheduleDTO){
    this.deleting = true

    this.dialog.open(ConfirmationDialogComponent, {
      data: 'Do you want to delete this schedule?'
    }).afterClosed().subscribe((response) => {
      if(response === true && schedule?.id != null){
        this.backupService.deleteBackupSchedule(schedule.id)
        .then(response => {
          this.toastr.success('Schedule deleted!')
          this.getBackupSchedules()
        })
        .catch(error => {
          this.toastr.error('Error deleting this schedule.')
        })
        .finally(() => {
          this.deleting = false
        })
      }else{
        this.deleting = false
      }
    })
  }
}
